import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  body {
    ${({ styles }) => styles}
  }
`;

export default GlobalStyles;
